(function () {
    'use strict';
    a3_pilot_reports.factory('LeaveRequestFactory', LeaveRequestFactory);

    /**
     * @memberof PilotReports
     * @ngdoc factory
     * @name LeaveRequestFactory
     * @description 
     *    Get Leave Request Configuration Data and submit new Leave Request
     * @ngInject
     */
    function LeaveRequestFactory(GenericService, $http, $q, apiUrl) {

       
        var service = {
            getConfigurationDetails : getConfigurationDetails,
            saveLeaveRequestInformation : saveLeaveRequestInformation,
            getLeaveRequestInformation : getLeaveRequestInformation,
            saveLeaveRequest : saveLeaveRequest
        };
        
        /**
        * Initialize the LeaveRequestInformation
        * @memberof LeaveRequestFactory
        */
        function LeaveRequestInformation(){
            
        }
        
        var objType = 'LeaveRequestInformation';
		var objCallback = LeaveRequestInformation; 
        
        var leaveRequestApiURL = apiUrl + '/LeaveRequest';
        
        
        /**
         * Get the LeaveRequestInformation and the qualification Group
         * @memberof LeaveRequestFactory
         * @param {function} callback  an on success callback function
         * @param {function} errorCallback  an on error callback function
         */
        function getConfigurationDetails(callback,errorCallback) {
           return $http.get(leaveRequestApiURL, { 'Content-Type': 'application/json' })
                .then(function(responseData){
                    if(responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation){
                           saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
                    }
                    callback(responseData);
                 })
                .catch(errorCallback);
        }
         
        function saveLeaveRequest(request,callback,errorCallback){
            var cleanRequest = angular.toJson(request);
            return $http.post(leaveRequestApiURL,cleanRequest ,{ 'Content-Type': 'application/json' })
                .then(function(responseData){
                    if(responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation){
                           saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
                    }
                    console.log(request);
                    callback(responseData);
                 })
                .catch(errorCallback);
        }
        /**
         * Save the leave Request Information  Object in local storage
         * @memberof LeaveRequestFactory
         * @param {object} leaveRequestInformation  a leaveRequestInformation
         */
        function saveLeaveRequestInformation(leaveRequestInformation){
            GenericService.saveOne(leaveRequestInformation,objType,objCallback);
        }
       	
        /**
         * Save the leave Request Information  Object in local storage
         * @memberof LeaveRequestFactory     
         * @returns {object} leaveRequestInformation  
         */
        function getLeaveRequestInformation(){
           return GenericService.getOne(objType,objCallback);
        }

  /*      function postProposal(proposal){
            return $http.post(apiUrl + '/bucket/PostProposal/', proposal, { 'Content-Type' : 'application/json' });
        }
     */

        return service;
    }


})();